import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Box,
    Text,
    VStack
} from '@chakra-ui/react'
import { Campaign } from 'graphql/types'
import React from 'react'

interface Props {
    Campaign: Campaign
}

export const Clicks = ({Campaign}: Props) => {
    const [clicksModal, setClicksModal] = React.useState<boolean>(false)
    const clickCount = Campaign.Clicks?.length || 0

    return (
        <>
            <Box
                onClick={() => setClicksModal(true)}
                cursor="pointer"
                textAlign="center"
                border="1px solid"
                borderColor="gray.300"
                borderRadius="md"
                p={4}
                w="150px"
                bg="gray.100"
                _hover={{ bg: 'gray.200' }}
                transition="background 0.2s"
            >
                <VStack spacing={2}>
                    <Text fontSize="lg" fontWeight="bold" textTransform="uppercase">
                        Clicks
                    </Text>
                    <Text fontSize="2xl" fontWeight="bold">
                        {clickCount}
                    </Text>
                </VStack>
            </Box>

            <Modal isOpen={clicksModal} onClose={() => setClicksModal(false)} size="6xl">
                <ModalOverlay />
                <ModalContent maxH="90vh">
                    <ModalHeader>Campaign Clicks</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody overflowY="auto" pb={6}>
                        {clickCount === 0 ? (
                            <Text>No clicks recorded for this campaign.</Text>
                        ) : (
                            <Table variant="simple">
                                <Thead>
                                    <Tr>
                                        <Th>Date</Th>
                                        <Th>Email</Th>
                                        <Th>Link</Th>
                                        <Th>Tags</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {Campaign.Clicks.map((click, i) => (
                                        <Tr key={i}>
                                            <Td>{click.Date}</Td>
                                            <Td>{click.EmailAddress}</Td>
                                            <Td>{click.Link}</Td>
                                            <Td>{click.Tags}</Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
